import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import './social-proof-plus-item.js';
import css_248z from './social-proof-plus.scss.js';

var _a;
const LitElementWithUtils = BaseWithUtils(s);
let uidCounter = 0;
class SocialProofPlus extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this._headlineId = (() => {
            uidCounter += 1;
            return `social-proof-plus-headline-${uidCounter}`;
        })();
        this.headline = '';
        this.items = [];
        this.columns = 1;
        this.query = '(max-width: 1365px)';
        this.isMobile = false;
    }
    get numberOfItems() {
        return this.items.length;
    }
    _handleMediaQuery(event) {
        this.isMobile = event.detail.value;
    }
    static _renderItem(item) {
        var _a;
        return $ `<social-proof-plus-item role="listitem" .name="${item.name}" .position="${item.position}" .paragraph="${item.paragraph}" .imageUrl="${item.imageUrl}" .imageAlt="${item.imageAlt}" .imageDecorative="${(_a = item.imageDecorative) !== null && _a !== void 0 ? _a : ''}" .ctaUrl="${item.ctaUrl}" .ctaLabel="${item.ctaLabel}" .ctaAriaLabel="${item.ctaAriaLabel}" .ctaTarget="${item.ctaTarget}" .ctaIsNoFollow="${item.ctaIsNoFollow}"></social-proof-plus-item>`;
    }
    render() {
        var _a;
        return $ `<section class="social-proof-plus ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''}" aria-labelledby="${l(this.headline ? this._headlineId : undefined)}">${this.headline
            ? $ `<h2 id="${this._headlineId}" class="social-proof-plus__headline">${this.headline}</h2>`
            : ''}<div class="social-proof-plus__container" role="list">${this.items.map((item) => SocialProofPlus._renderItem(item))}</div></section><lit-media-query .query="${this.query}" @changed="${this._handleMediaQuery}"></lit-media-query>`;
    }
}
SocialProofPlus.styles = [(_a = LitElementWithUtils.styles) !== null && _a !== void 0 ? _a : [], css_248z];
__decorate([
    e({ type: String })
], SocialProofPlus.prototype, "headline", void 0);
__decorate([
    e({ type: Array })
], SocialProofPlus.prototype, "items", void 0);
__decorate([
    t()
], SocialProofPlus.prototype, "columns", void 0);
__decorate([
    t()
], SocialProofPlus.prototype, "query", void 0);
__decorate([
    t()
], SocialProofPlus.prototype, "isMobile", void 0);
customElements.define('social-proof-plus', SocialProofPlus);

export { SocialProofPlus };
